import React from 'react';
import { Button, Layout, Menu } from 'antd';
import UserMenu from '@components/UserMenu';
import { useSelector } from 'react-redux';
import { login } from '@common/auth';

const { Header } = Layout;

const Topbar = () => {
  const user = useSelector(({ user }) => user);
  const isLoggedIn = (user) => user && user.roles;
  

	const menuKey = [
		'dashboard',
		'resource',
		'cost',
		'security',
		'identity'
	]
  return (
    <div className="akac-header">
      <Header className="akac-header-container" style={{justifyContent:'space-between'}}>
        <div></div>
				<Menu mode="horizontal" selectedKeys={'identity'} style={{minWidth: 500}}>
					<Menu.Item key="dashboard">
						<a href={`${process.env.REACT_APP_PORTAL}/dashboard`}>
							Dashboard
						</a>
					</Menu.Item>
					<Menu.Item key="resource">
						<a href={`${process.env.REACT_APP_PORTAL}/resource`}>
							Resource
						</a>
					</Menu.Item>
					<Menu.Item key="cost">
					<a href={`${process.env.REACT_APP_EXPENSE}`}>
						Cost
					</a>
					
					</Menu.Item>
					<Menu.Item key="security">
					<a href={`${process.env.REACT_APP_SECURITY_ASSURANCE}`}>
						Security
					</a>
					
					</Menu.Item>
					<Menu.Item key="identity">
					<a href={`${process.env.REACT_APP_IDENTITY}`}>
						Identity
					</a>
					
					</Menu.Item>
				</Menu>
				<div className='akac-header-right-panel' style={{display:'flex'}}>
        {isLoggedIn(user) ? (
          <UserMenu />
        ) : (
          <Button
            className="akac-header-login-btn"
            type="primary"
            onClick={login}
          >
            Login
          </Button>
        )}
        </div>
      </Header>
    </div>
  );
};
export default Topbar;
